// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  position: relative;
}

body {
  font-family: benton-sans, sans-serif;
}

h1, h2, h3, h4, h5, h6, p, a, li, button, th, td {
  color: rgb(51, 51, 51);
}
`, "",{"version":3,"sources":["webpack://./src/client/styles/global.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["#root {\n  position: relative;\n}\n\nbody {\n  font-family: benton-sans, sans-serif;\n}\n\nh1, h2, h3, h4, h5, h6, p, a, li, button, th, td {\n  color: rgb(51, 51, 51);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
